import axiosInstance from './axiosConfig';

const accountTypesAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/account-types', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch account types';
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/account-types/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch account type';
    }
  },

  create: async (payload) => {
    try {
      const response = await axiosInstance.post('/account-types', payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create account type';
    }
  },

  update: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/account-types/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update account type';
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/account-types/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete account type';
    }
  },

  getEnums: async () => {
    try {
      const response = await axiosInstance.get('/account-types/types/enums');
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch account type enums';
    }
  },
};

export default accountTypesAPI;
